import React, { createContext, FC, useEffect, useState } from 'react';
import cls from './FilterSub.module.css';
import classNames from 'classnames';
import { FilterSubBody } from './FilterSubBody/FilterSubBody';
import { FilterSubFooter } from './FilterSubFooter/FilterSubFooter';

export const FilSubContext = createContext({});
export const FilterSub = ({}) => {
    const [isOpenList, setIsOpenList] = useState(false);
    const [listSub, setListSub] = useState([]);
    const [activeSubs, setActiveSubs] = useState([
        {
            guid: 'all',
            title: i18next.t('FilterSub.useState.title')
        }
    ]);
    const [totals, setTotals] = useState({
        done: 0,
        receipt: 0,
        paid: 0,
        advancePayment: 0,
        debt: 0,
    });
    useEffect(() => {
        const handler = (e) => {
            setIsOpenList(false);
        };

        window.addEventListener('click', handler);
        return () => {
            window.removeEventListener('click', handler);
        };
    }, []);

    useEffect(() => {
        const initListSub = [];
        const $subs = $(document).find('.parent-block-top');
        $($subs).each(function () {
            const title = $(this).attr('data-name');
            const guid = $(this).attr('data-filter');
            initListSub.push({ title, guid });
        });
        setListSub(initListSub);
    }, []);

    const [filterTitle, setFilterTitle] = useState(i18next.t('FilterSub.useState.title'));

    const showHandler = () => {
        setIsOpenList((prevState) => !prevState);
    };

    const filSubContextValue = {
        activeSubs,
        setActiveSubs,
        listSub,
        setIsOpenList,
        setFilterTitle,
        totals,
        setTotals,
    };
    return (
        <FilSubContext.Provider value={filSubContextValue}>
            <div onClick={(e) => e.stopPropagation()} className={classNames(cls.filterSubWrapper)}>
                <div
                    onClick={showHandler}
                    className={classNames(cls.activeOption, { [cls.open]: isOpenList })}
                >
                    <span>{activeSubs.length ? filterTitle : i18next.t('FilterSub.useState.title')}</span>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11.8486 5.51562H4.15173C3.92087 5.51562 3.79196 5.75937 3.93493 5.92578L7.78337 10.3883C7.89353 10.516 8.10564 10.516 8.21696 10.3883L12.0654 5.92578C12.2084 5.75937 12.0795 5.51562 11.8486 5.51562Z"
                            fill="#757575"
                        />
                    </svg>
                </div>
                {isOpenList && (
                    <div className={classNames(cls.list)}>
                        <FilterSubBody listSub={listSub} />
                        <FilterSubFooter />
                    </div>
                )}
            </div>
        </FilSubContext.Provider>
    );
};
